/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type {
  CustomCardIntegration,
  ReadCustomCardIntegrationByIdApiResponse,
  ReadCustomCardIntegrationsApiResponse,
} from 'lib-shared-types-api';

const transformCardType = (card: any): CustomCardIntegration => {
  const { integration_type } = card;

  card.integration_type =
    integration_type === 'salesforceusernamepasswordflow'
      ? 'salesforce'
      : integration_type;

  return card as CustomCardIntegration;
};

export function transformCustomCardIntegrationByIdResponse(
  response: any,
): ReadCustomCardIntegrationByIdApiResponse {
  transformCardType(response.data);
  return response;
}

export function transformCustomCardIntegrationsResponse(
  response: any,
): ReadCustomCardIntegrationsApiResponse {
  response.data.custom_cards.forEach(transformCardType);
  return response;
}
